import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-x600h-data",
  "use": "icon-soc-x600h-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-x600h-data\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"160\" y=\"192\" width=\"704\" height=\"480\" rx=\"32\" /><path d=\"M224 256h576v352H224z\" fill=\"#fff\" fill-opacity=\".2\" /><path d=\"M288 352h80v192H288zM416 288h80v256H416zM544 320h80v224H544z\" fill=\"#fff\" /><path d=\"M384 704h256v64H384zM320 768h384v48H320z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-x600h-data.svg
// module id = QF8t
// module chunks = 546